module.exports = __webpack_public_path__ + "resources/img/img_edb_1_en.308b752625dad5102dd86a0e0de75432.png";